@import 'styles/mixins';
@import 'styles/variables';
@import 'styles/blaze/mixins';

.blaze_pro {
  --plan-color: #7d01ff;
}

.blaze_creator {
  --plan-color: #159d2c;
}

.blaze_team {
  --plan-color: #f822ff;
}

.blaze_agency {
  --plan-color: #008bea;
}

.header {
  margin-bottom: 10px;
  padding-top: 20px;
}

.spinnerContainer {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
}

.horizontalRuler {
  background: var(--dark-4, rgba(0, 0, 0, 0.04));
  height: 1px;
  margin: 31px 0;
}

.questionCopy {
  color: var(--dark-60, rgba(0, 0, 0, 0.6));
  @include sm-sohne;
  margin-top: 5px;
}
